<template>
    <div>
        <b-row class="mb-2">
            <b-col class="text-right">
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'TicketContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
            }
        }
    }
</script>
